"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarNameMode = exports.CalenderShowNames = void 0;
var CalenderShowNames;
(function (CalenderShowNames) {
    CalenderShowNames[CalenderShowNames["None"] = 0] = "None";
    CalenderShowNames[CalenderShowNames["Initials"] = 1] = "Initials";
    CalenderShowNames[CalenderShowNames["Full_Name"] = 2] = "Full_Name";
})(CalenderShowNames = exports.CalenderShowNames || (exports.CalenderShowNames = {}));
var CalendarNameMode;
(function (CalendarNameMode) {
    CalendarNameMode[CalendarNameMode["None"] = 0] = "None";
    CalendarNameMode[CalendarNameMode["Prepend"] = 1] = "Prepend";
    CalendarNameMode[CalendarNameMode["Append"] = 2] = "Append";
})(CalendarNameMode = exports.CalendarNameMode || (exports.CalendarNameMode = {}));
//# sourceMappingURL=usercalendar.js.map